import React from "react";
import {
  BarChart,
  Bar,
  CartesianGrid,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
} from "recharts";
import {
  Card,
  CardContent,
  CardDescription,
  CardFooter,
  CardHeader,
  CardTitle,
} from "../ui/card";

interface SalesCycleLengthProps {
  data: {
    name: string;
    salesCycle: number;
  }[];
}

const SalesCycleLength: React.FC<SalesCycleLengthProps> = ({ data }) => {
  console.log("🔍 SalesCycleLength: Data received:", data);
  console.log("🔍 SalesCycleLength: Data length:", data?.length || 0);
  console.log("🔍 SalesCycleLength: Has non-zero cycles?", data?.some(d => (d.salesCycle || 0) > 0));
  
  const hasData = data && data.length > 0 && data.some(d => (d.salesCycle || 0) > 0);

  return (
    <Card className="w-full h-full flex flex-col">
      <CardHeader className="pb-4 mb-4 border-b border-gray-200 flex-shrink-0">
        <CardTitle className="text-accent text-2xl">Sales Cycle Length</CardTitle>
        <CardDescription className="text-sm mb-2">
          Average days to close a deal per agent
        </CardDescription>
      </CardHeader>
      <CardContent className="pt-0 flex-1 min-h-0 flex flex-col">
        {!hasData ? (
          <div className="flex items-center justify-center h-[400px] text-muted-foreground text-sm">
            <p>No sales cycle data available</p>
          </div>
        ) : (
          <div className="mt-auto w-full flex items-end justify-start -mb-4">
            <ResponsiveContainer width="100%" height={400}>
            <BarChart data={data} margin={{ top: 10, right: 15, left: 5, bottom: 80 }}>
              <CartesianGrid strokeDasharray="3 3" stroke="#e5e7eb" />
              <XAxis 
                dataKey="name" 
                tick={{ fontSize: 11, fill: '#6b7280' }}
                angle={-45}
                textAnchor="end"
                height={80}
              />
              <YAxis 
                tick={{ fontSize: 11, fill: '#6b7280' }}
                width={50}
                label={{ value: 'Days', angle: -90, position: 'insideLeft', style: { fontSize: '11px', fill: '#6b7280' } }}
              />
              <Tooltip 
                formatter={(value: number) => [`${value} days`, 'Sales Cycle']}
                contentStyle={{ fontSize: '12px', padding: '8px' }}
                labelStyle={{ fontSize: '11px', marginBottom: '4px' }}
              />
              <Bar dataKey="salesCycle" fill="hsl(var(--chart-3))" radius={[4, 4, 0, 0]} />
            </BarChart>
          </ResponsiveContainer>
          </div>
        )}
      </CardContent>
      <CardFooter className="flex-shrink-0 border-t border-gray-100 pt-3 pb-3">
        <p className="text-sm text-muted-foreground leading-relaxed">
          <span className="font-medium text-foreground">Insight:</span> Measuring how long agents take to finalize deals from prospect to customer stage.
        </p>
      </CardFooter>
    </Card>
  );
};

export default SalesCycleLength;
